module.exports = __webpack_public_path__ + "img/direntrega.347ccb36.png";